/** Formatting for numbers, money, dates and sizes. en-IN by default (India data plane). */
const LOCALE = 'en-IN'

export const fmtNumber = (n: number | null | undefined, digits = 0): string =>
  n == null || Number.isNaN(n) ? '—' : n.toLocaleString(LOCALE, { maximumFractionDigits: digits, minimumFractionDigits: 0 })

/** Money from minor units (paise/cents). */
export const fmtMoney = (minor: number | null | undefined, currency = 'INR'): string =>
  minor == null ? '—' : (minor / 100).toLocaleString(LOCALE, { style: 'currency', currency, maximumFractionDigits: minor % 100 === 0 ? 0 : 2 })

export const fmtDate = (d: string | Date | null | undefined): string =>
  !d ? '—' : new Date(d).toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' })

export const fmtDateTime = (d: string | Date | null | undefined): string =>
  !d ? '—' : new Date(d).toLocaleString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })

export function fmtRelative(d: string | Date | null | undefined): string {
  if (!d) return '—'
  const ms = Date.now() - new Date(d).getTime()
  const abs = Math.abs(ms)
  const fut = ms < 0
  const unit = (n: number, u: string) => (fut ? `in ${n} ${u}${n === 1 ? '' : 's'}` : `${n} ${u}${n === 1 ? '' : 's'} ago`)
  if (abs < 45_000) return fut ? 'in a moment' : 'just now'
  if (abs < 3_600_000) return unit(Math.round(abs / 60_000), 'minute')
  if (abs < 86_400_000) return unit(Math.round(abs / 3_600_000), 'hour')
  if (abs < 30 * 86_400_000) return unit(Math.round(abs / 86_400_000), 'day')
  return fmtDate(d)
}

export function fmtBytes(n: number | null | undefined): string {
  if (n == null) return '—'
  const u = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  let v = n
  while (v >= 1024 && i < u.length - 1) {
    v /= 1024
    i++
  }
  return `${v.toLocaleString(LOCALE, { maximumFractionDigits: v < 10 && i > 0 ? 1 : 0 })} ${u[i]}`
}

export const pluralize = (n: number, one: string, many = `${one}s`): string => `${fmtNumber(n)} ${n === 1 ? one : many}`
